import { hasCustomRoles } from './hasCustomRoles';
import { hasTeamCustomRoles } from './hasTeamCustomRoles';
import { isAdmin } from './isAdmin';
import { isOwner } from './isOwner';
import type { Member } from './types';

export function hasAdminRights(member: Member) {
  return isOwner(member) || isAdmin(member) || hasCustomRoles(member) || hasTeamCustomRoles(member);
}
